import { createFromIconfontCN } from '@ant-design/icons';
import { icon } from '@/assets/iconSider/iconfont'
const IconFontSider = createFromIconfontCN({ scriptUrl: { icon } });

export default IconFontSider;